<style lang="scss">
  @import "@/assets/scss/vuexy/pages/Detail.scss";
  @import "@/assets/scss/vuexy/pages/Config.scss";

  .container-schedule{
    border-bottom: 2px solid #f0f0f0;
  }
</style>
<template>
  <div>
    <div class="vx-row w-full">
        <vs-button :to="`/luminarias`" class="w-full my-2 sm:w-auto" color="primary" type="filled">{{$t('Labels.Back')}}</vs-button>
    </div>
    <div class="vx-row w-full">
      <div class="w-full sm:w-auto  p-1">
        <vx-card class="p-4 pt-6 h-full flex items-center justify-center">
          <div class="text-center mt-2">
            <iconLight width="120" height="120" iconColor="#ffbd59" :level="Math.ceil(parseInt(response.dimming) * 100 / 255)" />
          </div>
        </vx-card>
      </div>
      <div class="flex-grow flex-1 p-1">
        <vx-card class="p-4 pt-6 h-full w-full flex items-center justify-center">
            <feather-icon v-if="!editLuminary"  @click="editLuminary = true" icon="EditIcon" svgClasses="h-5 w-5 text-grey-ligth" class="float-right cursor-pointer hover:text-primary"/>
            <feather-icon v-if="editLuminary" @click="editLuminary = false" icon="XIcon" svgClasses="h-5 w-5 text-grey-ligth" class="float-right cursor-pointer hover:text-primary"/>
            <feather-icon v-if="editLuminary" @click="requestPassword('U')" icon="SaveIcon" svgClasses="h-5 w-5 text-grey-ligth" class="float-right cursor-pointer hover:text-primary"/> 
            <div class="text-center">{{$t('Labels.LuminaryInformation')}}</div>
            <div >
              <div class="w-full p-2 py-4 sm:w-1/3 sm:inline-block">
                <div v-if="!editLuminary" class="text-xs text-center mb-1">{{$t('Labels.Name')}}</div>
                <div v-if="!editLuminary" class="font-bold text-center">{{response.name}}</div>
                <vs-input v-else :label="$t('Labels.Name')" type="text" v-model="name" /> 
              </div>
              <div class="w-full p-2 py-4 sm:w-1/3 sm:inline-block">
                <div  class="text-xs text-center mb-1">{{$t('Labels.Voltage')}}</div>
                <div class="text-center" v-if="response.voltage_failure == '0'">
                  <div class="w-10 h-10 inline-block rounded-full align-middle bg-success" ></div>
                  <div class="inline-block align-middle ml-2 font-bold">OK</div>
                </div>
                <div class="text-center" v-else>
                  <div class="w-10 h-10 inline-block rounded-full align-middle bg-danger" ></div>
                  <div class="inline-block align-middle ml-2 font-bold">Error</div>
                </div>
              </div>
              <div class="w-full p-2 py-4 sm:w-1/3 sm:inline-block">
                <div  class="text-xs text-center mb-1">{{$t('Labels.Inclination')}}</div>
                <div class="text-center" v-if="parseInt(response.inclination) < 45">
                  <div class="w-10 h-10 inline-block rounded-full align-middle bg-success" ></div>
                  <div class="inline-block align-middle ml-2 font-bold">OK</div>
                </div>
                <div class="text-center" v-else>
                  <div class="w-10 h-10 inline-block rounded-full align-middle bg-danger" ></div>
                  <div class="inline-block align-middle ml-2 font-bold">Error</div>
                </div>
              </div>
              <div class="w-full p-2 py-4 sm:w-1/3 sm:inline-block">
                <div  class="text-xs text-center mb-1">{{$t('Labels.Circuit')}}</div>
                <div class="text-center" v-if="response.luminaires_circuit">
                  <div class="w-10 h-10 inline-block rounded-sm align-middle" :style="{ 'background-color': response.luminaires_circuit.color }"></div>
                  <div class="inline-block align-middle ml-2 font-bold">{{response.luminaires_circuit.name}}</div>
                </div>
                <div v-else class="text-center">N/A</div>
              </div>
              <div class="w-full p-2 py-4 sm:w-1/3 sm:inline-block">
                <div  class="text-xs text-center mb-1">{{$t('Labels.Current')}}</div>
                <div class="text-center" v-if="response.current_failure == '0'">
                  <div class="w-10 h-10 inline-block rounded-full align-middle bg-success" ></div>
                  <div class="inline-block align-middle ml-2 font-bold">OK</div>
                </div>
                <div class="text-center" v-else>
                  <div class="w-10 h-10 inline-block rounded-full align-middle bg-danger" ></div>
                  <div class="inline-block align-middle ml-2 font-bold">Error</div>
                </div>
              </div>
              <div class="w-full p-2 py-4 sm:w-1/3 sm:inline-block">
                <div  class="text-xs text-center mb-1">{{$t('Labels.Dimming')}}</div>
                <div class="text-center" v-if="response.dimming_failure == '0'">
                  <div class="w-10 h-10 inline-block rounded-full align-middle bg-success" ></div>
                  <div class="inline-block align-middle ml-2 font-bold">OK</div>
                </div>
                <div class="text-center" v-else>
                  <div class="w-10 h-10 inline-block rounded-full align-middle bg-danger" ></div>
                  <div class="inline-block align-middle ml-2 font-bold">Error</div>
                </div>
              </div>
            </div>
        </vx-card>
      </div>
      <div class="w-full sm:w-auto  p-1">
        <vx-card class="p-4 pt-6 h-full flex items-center justify-center">
          <div class="map-container m-2" v-if="status_mapa">
            <l-map :center="center" :zoom="zoom" v-if="response" ref="mymap">
                <l-tile-layer :attribution="attribution" :url="url">
                </l-tile-layer>
                <l-marker :lat-lng="marker" ref="position_marker">
                    <l-icon :icon-anchor="staticAnchor">
                        <iconMarker width="25" height="25" iconColor="#4dc770" />
                    </l-icon>
                </l-marker>
            </l-map>
          </div>
        </vx-card>
      </div>
    </div>
    <div class="vx-row w-full">
      <div  class="w-full p-1">
        <vx-card class="p-6 h-full flex items-center justify-center">
          <div class="text-center my-2">
            <div class="inline-block align-middle font-bold" >Fijo</div>
            <div class="inline-block align-middle mx-2">
              <vs-switch v-model="banSchedule" color="success"/>
            </div>
            <div class="inline-block align-middle font-bold">Por horarios</div>
          </div>
          <div class="w-full" v-if="!banSchedule">
            <div class="w-full sm:w-1/3 sm:inline-block"></div>
            <div class="w-full sm:w-1/3 sm:inline-block">
              <div class="text-center mt-2">
                <iconLight width="120" height="120" iconColor="#ffbd59" :level="slideLight" />
              </div>
              <div class="text-center mt-2">
                <div class="inline-block align-middle font-bold" :class="{'text-grey': controlLight }" >Off</div>
                <div class="inline-block align-middle mx-2">
                  <vs-switch v-model="controlLight" color="success"/>
                </div>
                <div class="inline-block align-middle font-bold" :class="{'text-grey': !controlLight }">On</div>
              </div>
              <div>
                <vs-slider v-model="slideLight" :min="0" :max="100" text-fixed="%"/>
              </div>
              <div class="text-center">
                <vs-button @click="requestPassword('G')" color="primary" class="mr-2 mt-6">{{$t('Labels.Apply')}}</vs-button>
              </div>
            </div>
            <div class="w-full sm:w-1/3 sm:inline-block"></div>
          </div>
          <div v-if="banSchedule">
            <div class="block h-16 p-2">
              <vs-button color="primary" class="float-right" @click="addSchedule()">{{$t('Labels.Add')}}</vs-button>
            </div>
            <div class="container-schedule" v-for="(item, index) in schedules" v-bind:key="index">
              <div class="w-full sm:w-1/4 sm:inline-block sm:p-4">
                <div class="text-center mb-2">{{$t('Labels.StartDimming')}}</div>
                <div class="text-center">
                  <iconLight width="80" height="80" iconColor="#ffbd59" :level="item.startDimming" />
                </div>
                <div>
                  <vs-slider v-model="item.startDimming" :min="0" :max="100" text-fixed="%"/>
                </div>
              </div>
              <div class="w-full sm:w-1/4 sm:inline-block sm:p-4">
                <div class="text-center mb-2">{{$t('Labels.EndDimming')}}</div>
                <div class="text-center">
                  <iconLight width="80" height="80" iconColor="#ffbd59" :level="item.endDimming" />
                </div>
                <div>
                  <vs-slider v-model="item.endDimming" :min="0" :max="100" text-fixed="%"/>
                </div>
              </div>
              <div class="w-full sm:w-1/2 sm:inline-block sm:p-4 align-top">
                <div class="w-full sm:w-2/5 sm:inline-block sm:p-4 align-top">
                  <div class="text-center mb-2">{{$t('Labels.StartTime')}}</div>
                  <div class="text-center">
                    <vue-timepicker format="HH:mm" v-model="item.startSchedule"></vue-timepicker>
                  </div>
                </div>
                <div class="w-full sm:w-2/5 sm:inline-block sm:p-4 align-top">
                  <div class="text-center mb-2">{{$t('Labels.EndTime')}}</div>
                  <div class="text-center">
                    <vue-timepicker format="HH:mm" v-model="item.endSchedule"></vue-timepicker>
                  </div>
                </div>
                <div class="w-full sm:w-1/5 sm:inline-block text-center mt-10">
                  <feather-icon @click="deleteSchedule(index)" icon="TrashIcon" svgClasses="h-8 w-8 text-danger" class="cursor-pointer hover:text-primary"/>
                </div>
              </div>
            </div>
            <div class="text-right">
              <vs-button @click="requestPassword('C')" color="primary" class="mr-2 mt-6">{{$t('Labels.Apply')}}</vs-button>
            </div>
          </div>
        </vx-card>
      </div>
    </div>
    <div class="text-center my-2 text-2xl">{{$t('Labels.LuminaryMeasurements')}}</div>
    <div class="vx-row p-1">
      <vx-card class="p-6 h-full">
        <div class="w-full sm:flex flex-row">
          <div class="w-full sm:flex-1 text-center">
            <div class="text-sm">{{$t('Labels.Current')}} RMS</div>
            <div>
              <vx-tooltip class="inline-block" :text="response.alertas_corriente === '0'?$t('Messages.Correct'):$t('Messages.Alert')">
                <div class="inline-block shadow-drop d-theme-dark-bg cursor-pointer round py-1 px-2 align-middle bg-success"  v-if="response.alertas_corriente === '0'">
                  <feather-icon icon="CheckIcon" svgClasses="h-5 w-5 text-white align-middle"  />
                </div>
                <div class="inline-block shadow-drop d-theme-dark-bg cursor-pointer round py-1 px-2 align-middle bg-danger" v-else>
                  <feather-icon icon="AlertTriangleIcon" svgClasses="h-5 w-5 text-white" />
                </div>
              </vx-tooltip>
              <div class="inline-block align-middle ml-2 text-4xl font-bold">{{response.electric_current}} A</div>
            </div>
          </div>
          <div class="w-full sm:flex-1 text-center">
            <div class="text-sm">{{$t('Labels.Voltage')}} RMS</div>
            <div>
              <vx-tooltip class="inline-block" :text="response.alertas_voltaje === '0'?$t('Messages.Correct'):$t('Messages.Alert')">
                <div class="inline-block shadow-drop d-theme-dark-bg cursor-pointer round py-1 px-2 align-middle bg-success"  v-if="response.alertas_voltaje === '0'">
                  <feather-icon icon="CheckIcon" svgClasses="h-5 w-5 text-white align-middle"  />
                </div>
                <div class="inline-block shadow-drop d-theme-dark-bg cursor-pointer round py-1 px-2 align-middle bg-danger" v-else>
                  <feather-icon icon="AlertTriangleIcon" svgClasses="h-5 w-5 text-white" />
                </div>
              </vx-tooltip>
              <div class="inline-block align-middle ml-2 text-4xl font-bold">{{response.electric_voltage}} V</div>
            </div>
          </div>
          <div class="w-full sm:flex-1 text-center">
            <div class="text-sm">{{$t('Labels.ActivePower')}}</div>
            <div>
              <vx-tooltip class="inline-block" :text="response.alertas_potencia === '0'?$t('Messages.Correct'):$t('Messages.Alert')">
                <div class="inline-block shadow-drop d-theme-dark-bg cursor-pointer round py-1 px-2 align-middle bg-success"  v-if="response.alertas_potencia === '0'">
                  <feather-icon icon="CheckIcon" svgClasses="h-5 w-5 text-white align-middle"  />
                </div>
                <div class="inline-block shadow-drop d-theme-dark-bg cursor-pointer round py-1 px-2 align-middle bg-danger" v-else>
                  <feather-icon icon="AlertTriangleIcon" svgClasses="h-5 w-5 text-white" />
                </div>
              </vx-tooltip>
              <div class="inline-block align-middle ml-2 text-4xl font-bold">{{response.active_power}} W</div>
            </div>
          </div>
          <div class="w-full sm:flex-1 text-center">
            <div class="text-sm">{{$t('Labels.ReactivePower')}}</div>
            <div>
              <vx-tooltip class="inline-block" :text="response.alertas_potencia_reactiva === '0'?$t('Messages.Correct'):$t('Messages.Alert')">
                <div class="inline-block shadow-drop d-theme-dark-bg cursor-pointer round py-1 px-2 align-middle bg-success"  v-if="response.alertas_potencia_reactiva === '0'">
                  <feather-icon icon="CheckIcon" svgClasses="h-5 w-5 text-white align-middle"  />
                </div>
                <div class="inline-block shadow-drop d-theme-dark-bg cursor-pointer round py-1 px-2 align-middle bg-danger" v-else>
                  <feather-icon icon="AlertTriangleIcon" svgClasses="h-5 w-5 text-white" />
                </div>
              </vx-tooltip>
              <div class="inline-block align-middle ml-2 text-4xl font-bold">{{response.reactive_power}} VAR</div>
            </div>
          </div>
          <div class="w-full sm:flex-1 text-center">
            <div class="text-sm">{{$t('Labels.ApparentPower')}}</div>
            <div>
              <vx-tooltip class="inline-block" :text="response.alertas_potencia_aparente === '0'?$t('Messages.Correct'):$t('Messages.Alert')">
                <div class="inline-block shadow-drop d-theme-dark-bg cursor-pointer round py-1 px-2 align-middle bg-success"  v-if="response.alertas_potencia_aparente === '0'">
                  <feather-icon icon="CheckIcon" svgClasses="h-5 w-5 text-white align-middle"  />
                </div>
                <div class="inline-block shadow-drop d-theme-dark-bg cursor-pointer round py-1 px-2 align-middle bg-danger" v-else>
                  <feather-icon icon="AlertTriangleIcon" svgClasses="h-5 w-5 text-white" />
                </div>
              </vx-tooltip>
              <div class="inline-block align-middle ml-2 text-4xl font-bold">{{response.apparent_power}} VA</div>
            </div>
          </div>
        </div>
      </vx-card>
    </div>
    <div class="vx-row p-1">
      <vx-card class="p-6 h-full">
        <div class="w-full sm:flex flex-row">
          <div class="w-full sm:flex-1 text-center">
            <div class="text-sm">{{$t('Labels.PowerFactor')}}</div>
            <div>
              <vx-tooltip class="inline-block" :text="response.alertas_factor_potencia === '0'?$t('Messages.Correct'):$t('Messages.Alert')">
                <div class="inline-block shadow-drop d-theme-dark-bg cursor-pointer round py-1 px-2 align-middle bg-success"  v-if="response.alertas_factor_potencia === '0'">
                  <feather-icon icon="CheckIcon" svgClasses="h-5 w-5 text-white align-middle"  />
                </div>
                <div class="inline-block shadow-drop d-theme-dark-bg cursor-pointer round py-1 px-2 align-middle bg-danger" v-else>
                  <feather-icon icon="AlertTriangleIcon" svgClasses="h-5 w-5 text-white" />
                </div>
              </vx-tooltip>
              <div class="inline-block align-middle ml-2 text-4xl font-bold">{{response.factor_power}}</div>
            </div>  
          </div>
          <div class="w-full sm:flex-1 text-center">
            <div class="text-sm">{{$t('Labels.ActiveEnergy')}}</div>
            <div>
              <vx-tooltip class="inline-block" :text="response.alertas_active_energy === '0'?$t('Messages.Correct'):$t('Messages.Alert')">
                <div class="inline-block shadow-drop d-theme-dark-bg cursor-pointer round py-1 px-2 align-middle bg-success"  v-if="response.alertas_factor_potencia === '0'">
                  <feather-icon icon="CheckIcon" svgClasses="h-5 w-5 text-white align-middle"  />
                </div>
                <div class="inline-block shadow-drop d-theme-dark-bg cursor-pointer round py-1 px-2 align-middle bg-danger" v-else>
                  <feather-icon icon="AlertTriangleIcon" svgClasses="h-5 w-5 text-white" />
                </div>
              </vx-tooltip>
              <div class="inline-block align-middle ml-2 text-4xl font-bold">{{response.active_energy}} Wh</div>
            </div>  
          </div>
          <div class="w-full sm:flex-1 text-center">
            <div class="text-sm">{{$t('Labels.ReactiveEnergy')}}</div>
            <div>
              <vx-tooltip class="inline-block" :text="response.alertas_reactive_energy === '0'?$t('Messages.Correct'):$t('Messages.Alert')">
                <div class="inline-block shadow-drop d-theme-dark-bg cursor-pointer round py-1 px-2 align-middle bg-success"  v-if="response.alertas_factor_potencia === '0'">
                  <feather-icon icon="CheckIcon" svgClasses="h-5 w-5 text-white align-middle"  />
                </div>
                <div class="inline-block shadow-drop d-theme-dark-bg cursor-pointer round py-1 px-2 align-middle bg-danger" v-else>
                  <feather-icon icon="AlertTriangleIcon" svgClasses="h-5 w-5 text-white" />
                </div>
              </vx-tooltip>
              <div class="inline-block align-middle ml-2 text-4xl font-bold">{{response.reactive_energy}} VARh</div>
            </div>
          </div>
          <div class="w-full sm:flex-1 text-center">
            <div class="text-sm">{{$t('Labels.Frequency')}}</div>
            <div>
              <vx-tooltip class="inline-block" :text="response.alertas_frecuencia === '0'?$t('Messages.Correct'):$t('Messages.Alert')">
                <div class="inline-block shadow-drop d-theme-dark-bg cursor-pointer round py-1 px-2 align-middle bg-success"  v-if="response.alertas_frecuencia === '0'">
                  <feather-icon icon="CheckIcon" svgClasses="h-5 w-5 text-white align-middle"  />
                </div>
                <div class="inline-block shadow-drop d-theme-dark-bg cursor-pointer round py-1 px-2 align-middle bg-danger" v-else>
                  <feather-icon icon="AlertTriangleIcon" svgClasses="h-5 w-5 text-white" />
                </div>
              </vx-tooltip>
              <div class="inline-block align-middle ml-2 text-4xl font-bold">{{response.frequency}} Hz</div>
            </div>
          </div>
        </div>
      </vx-card>
    </div>
    <div class="vx-row my-2 p-1 justify-evenly">
        <vs-button :to="`/luminarias/${uuid}/statistics`" class="w-full my-2 sm:w-auto" color="primary" type="filled">{{$t('Labels.Statistics')}}</vs-button>
        <vs-button :to="`/luminarias/${uuid}/history`" class="w-full my-2 sm:w-auto" color="#626262" type="filled">{{$t('Labels.History')}}</vs-button>
    </div>
    <div class="text-center my-2 text-2xl">{{$t('Labels.Alerts')}}</div>
    <vx-card class="p-6 h-full">
    <div class="container-alerts w-full" v-if="response.electric_current_min != undefined">
        <minMaxItem 
          :title="$t('Labels.Current')" 
          :min="response.electric_current_min" 
          :max="response.electric_current_max" 
          unit="" 
          :url="`luminaires_devices/alerts_ranges/luminary`" 
          :uuid="uuid"
          paramMin="electric_current_min" 
          paramMax="electric_current_max" 
          type="PUT"
          :rangeMin="0"
          :rangeMax="10"
          ></minMaxItem>
        
        <minMaxItem 
          :title="$t('Labels.Voltage')" 
          :min="response.electric_voltage_min" 
          :max="response.electric_voltage_max" 
          unit="" 
          :url="`luminaires_devices/alerts_ranges/luminary`" 
          :uuid="uuid"
          :paramMin="`electric_voltage_min`" 
          :paramMax="`electric_voltage_max`" 
          type="PUT"
          :rangeMin="0"
          :rangeMax="1000"
          ></minMaxItem>

        <minMaxItem 
          :title="$t('Labels.ActivePower')" 
          :min="response.active_power_min" 
          :max="response.active_power_max" 
          unit="" 
          :url="`luminaires_devices/alerts_ranges/luminary`" 
          :uuid="uuid"
          paramMin="active_power_min" 
          paramMax="active_power_max" 
          type="PUT"
          :rangeMin="0"
          :rangeMax="1000"
          ></minMaxItem>

        <minMaxItem 
          :title="$t('Labels.ReactivePower')" 
          :min="response.reactive_power_min" 
          :max="response.reactive_power_max" 
          unit="" 
          :url="`luminaires_devices/alerts_ranges/luminary`" 
          :uuid="uuid"
          paramMin="reactive_power_min" 
          paramMax="reactive_power_max" 
          type="PUT"
          :rangeMin="0"
          :rangeMax="1000"
          ></minMaxItem>

        <minMaxItem 
          :title="$t('Labels.ApparentPower')" 
          :min="response.apparent_power_min" 
          :max="response.apparent_power_max" 
          unit="" 
          :url="`luminaires_devices/alerts_ranges/luminary`" 
          :uuid="uuid" 
          paramMin="apparent_power_min" 
          paramMax="apparent_power_max" 
          type="PUT"
          :rangeMin="0"
          :rangeMax="1000"
          ></minMaxItem>

        <minMaxItem 
          :title="$t('Labels.PowerFactor')" 
          :min="response.factor_power_min" 
          :max="response.factor_power_max" 
          unit="" 
          :url="`luminaires_devices/alerts_ranges/luminary`" 
          :uuid="uuid" 
          paramMin="factor_power_min" 
          paramMax="factor_power_max" 
          type="PUT"
          :rangeMin="0"
          :rangeMax="1"
          :step="0.1"
          ></minMaxItem>

        <minMaxItem 
          :title="$t('Labels.ActiveEnergy')" 
          :min="response.active_energy_min" 
          :max="response.active_energy_max" 
          unit="" 
          :url="`luminaires_devices/alerts_ranges/luminary`" 
          :uuid="uuid"
          paramMin="active_energy_min" 
          paramMax="active_energy_max" 
          type="PUT"
          :rangeMin="0"
          :rangeMax="4294967295"
          ></minMaxItem>

        <minMaxItem 
          :title="$t('Labels.ReactiveEnergy')" 
          :min="response.reactive_energy_min" 
          :max="response.reactive_energy_max" 
          unit="" 
          :url="`luminaires_devices/alerts_ranges/luminary`" 
          :uuid="uuid"
          paramMin="reactive_energy_min" 
          paramMax="reactive_energy_max" 
          type="PUT"
          :rangeMin="0"
          :rangeMax="4294967295"
          ></minMaxItem>

        <minMaxItem 
          :title="$t('Labels.Frequency')" 
          :min="response.frequency_min" 
          :max="response.frequency_max" 
          unit="" 
          :url="`luminaires_devices/alerts_ranges/luminary`" 
          :uuid="uuid"
          paramMin="frequency_min" 
          paramMax="frequency_max" 
          type="PUT"
          :rangeMin="0"
          :rangeMax="100"
          ></minMaxItem>
      </div>
    </vx-card>
  </div>
</template>
<script>
import {request} from '@/request.js'
import listItem from '@/components/listItem/listItem.vue'
import VueApexCharts from 'vue-apexcharts'
import {
  LMap,
  LTileLayer,
  LMarker,
  LIcon
} from 'vue2-leaflet'
import 'leaflet-fullscreen/dist/leaflet.fullscreen.css'
import 'leaflet-fullscreen/dist/Leaflet.fullscreen'
import 'leaflet/dist/leaflet.css'
import iconLight from '@/components/icons/iconLight'
import iconMarker from '@/components/icons/iconMarker'
import statusItem from '@/components/statusItem/statusItem.vue'
import {globalPassActions} from '@/globalPass'
import {empty} from '@/helpers.js'
import minMaxItem from '@/components/minMaxItem/minMaxItem.vue'
import VueTimepicker from 'vue2-timepicker'
import 'vue2-timepicker/dist/VueTimepicker.css'
/* global L:true */

export default {
  components: {
    listItem,
    VueApexCharts,
    LMap,
    LTileLayer,
    LMarker,
    LIcon,
    iconLight,
    iconMarker,
    statusItem,
    minMaxItem,
    VueTimepicker
  },
  data () {
    return {
      response: [],
      uuid: this.$route.params.uuid,
      controlLight: false,
      slideLight:0,
      zoom:17,
      center: L.latLng(47.41322, -1.219482),
      url:'https://tiles.wmflabs.org/bw-mapnik/{z}/{x}/{y}.png',
      attribution:'',
      marker: L.latLng(47.41322, -1.219482),
      staticAnchor: [12, 27],
      icon_marker: [],
      status_mapa: false,
      timeStamp: new Date(), 
      ban: false,
      banSchedule: false,
      schedules: [
        {
          startDimming: 0,
          endDimming: 0,
          startSchedule: '00:00',
          endSchedule: '00:00'
        }
      ],
      banType: 'G',
      editLuminary: false,
      name: ''
    }
  },

  methods: {
    async getResponse () {
      const params = {
        url: `luminaires_devices/${this.uuid}`,
        method: 'GET'
      }
      await request(params).then(response => {
        this.response = response.data.data
        this.name = this.response.name || ''
        if (this.response.type === 'G') {
          this.banSchedule = false
          this.slideLight = Math.ceil(parseInt(this.response.dimming_set) * 100 / 255)
        } else {
          this.banSchedule = true
          this.setSchedule(JSON.parse(this.response.dimming_set))
        }
          
        if (this.response.latlong.length > 0) {
          const location = this.response.latlong.split(',')
          this.marker = L.latLng(location[0], location[1])
          this.center = L.latLng(location[0], location[1])
          this.status_mapa = true
          const me = this
          setTimeout(function () {
            const maps = me.$refs.mymap.mapObject
            maps.addControl(new L.Control.Fullscreen())
          }, 1000)
        }
      }).finally(() => {
        this.$vs.loading.close()
      })
      
    },
    setSchedule (data) {
      this.schedules = []
      data.forEach(element => {
        this.schedules.push({
          startDimming: element[0].dimming,
          endDimming: element[1].dimming,
          startSchedule: this.getHourString(element[0].hour),
          endSchedule: this.getHourString(element[1].hour)
        })
      })
    },
    getHourString (number) {
      let hour = Math.trunc(number / 60)
      if (hour.toString().length === 1) hour = `0${  hour}`
      let min = number % 60
      if (min.toString().length === 1) min = `0${  min}`
      return `${hour  }:${  min}`  
    },
    relativeTimeConvert (date) {
      return this.$dayjs().to(this.$dayjs(date))
    },
    async update () {
      console.log(this.slideLight)
      const params = {
        url: 'luminaires_devices/update_masive',
        method: 'PUT',
        params: {
          type: 'G',
          uuids: this.uuid,
          dimming_set: Math.ceil((this.slideLight * 255) / 100)
        }
      }
      await request(params).then(() => {
        this.getResponse()
      }).finally(() => {
        this.$vs.loading.close()
      })
    },
    requestPassword (type) {
      this.ban = true
      this.banType = type
      globalPassActions.show()
    },
    addSchedule () {
      if (this.schedules.length < 9) this.schedules.push({
        startDimming: 0,
        endDimming: 0,
        startSchedule: '00:00 AM',
        endSchedule: '00:00 AM'
      })
    },
    deleteSchedule (index) {
      this.schedules.splice(index, 1)
    },
    async updateSchedule () {
      const data = []
      this.schedules.forEach(element => {
        const start = element.startSchedule.split(':')
        const minutesStart = (parseInt(start[0]) * 60) + parseInt(start[1])
        const end = element.endSchedule.split(':')
        const minutesEnd = (parseInt(end[0]) * 60) + parseInt(end[1])
        const schedule = []
        schedule.push({
          hour: minutesStart,
          dimming: element.startDimming
        })
        schedule.push({
          hour: minutesEnd,
          dimming: element.endDimming
        })
        data.push(schedule)
      })
      const params = {
        url: 'luminaires_devices/update_masive',
        method: 'PUT',
        params: {
          type: 'C',
          uuids: this.uuid,
          dimming_set: JSON.stringify(data)
        }
      }
      await request(params).then(() => {
        this.getResponse()
      }).finally(() => {
        this.$vs.loading.close()
      })
    },
    async updateLuminary () {
      const params = {
        url: `luminaires_devices/${this.uuid}`,
        method: 'PUT',
        params: {
          name: this.name
        }
      }
      await request(params).then(() => {
        this.response.name = this.name
        this.editLuminary = false
      }).finally(() => {
        this.$vs.loading.close()
      })
    }
  },
  created () {
    this.getResponse()
  },
  computed: {
    isVisiblePassword () {
      return globalPassActions.getStatus()
    } 
  },
  watch: { 
    controlLight (newVal) {
      if (!newVal) this.slideLight = 0
      else if (this.slideLight === 0) this.slideLight = 100 
    },
    slideLight (newVal) {
      if (newVal > 0 && this.controlLight === false) this.controlLight = true
      else if (newVal === 0 && this.controlLight === true) this.controlLight = false
    },
    isVisiblePassword (visible) {
      const functions = {
        'U': this.updateLuminary,
        'G': this.update,
        'C': this.updateSchedule
      }
      if (!empty(globalPassActions.get()) && visible === false && this.ban === true) {
        functions[this.banType]()
        /*if (this.banType === 'U') {
        else if (this.banType === 'G') {
          this.update()
        } else {
          this.updateSchedule()
        } */
        this.ban = false
      } 
    }
  }
}
</script>